<template>
  <div class="toolbar" role="toolbar" aria-label="text formatting">
    <component
      v-for="item in toolbar"
      :is="item"
      :key="item"
      :selected="selected"
      @toolbar-action="$emit('toolbar-action', $event)"
      @layout-change="$emit('layout-change', $event)"
      @heading-change="$emit('heading-change', $event)"
    />
  </div>
</template>

<script>
import alignment from './Toolbar/Alignment.vue';
import formatting from './Toolbar/Formatting.vue';
import heading from './Toolbar/Heading.vue';
import layout from './Toolbar/Layout.vue';

export default {
  name: 'NodeEditorToolbar',
  components: {
    alignment,
    formatting,
    heading,
    layout,
  },
  props: {
    toolbar: {
      type: Array,
      required: true,
    },
    selected: {
      type: Range,
      default: () => new Range(),
    },
  },
};
</script>

<style>
.toolbar {
  display: flex;
  background: #f2f2f2;
  align-content: center;
}

.toolbar__group {
  display: flex;
  align-content: center;
  border-right: 1px solid #ccc;
}

.toolbar__btn {
  border: 0;
  background: transparent;
  color: #000;
  padding: 1rem;
}

.toolbar__btn svg {
  width: 1rem;
  height: 1rem;
}

.toolbar__select {
  color: inherit;
  background: transparent;
  border: 0px solid #ccc;
  font-size: 0.8rem;
  margin: auto 0.5rem;
  min-width: 20ch;
  padding: 0.25rem 1rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.toolbar__select::-ms-expand {
  display: none;
}

.toolbar__select-wrapper {
  position: relative;
}

.toolbar__select-wrapper::after {
  border-bottom: 2px solid #000;
  border-right: 2px solid #000;
  content: '';
  display: block;
  height: 8px;
  pointer-events: none;
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translate(0, -65%) rotate(45deg);
  width: 6px;
}
</style>
